var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgPaletteFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.146 12c0-5.385 4.366-9.75 9.75-9.75 1.802 0 3.257.373 4.478 1.164 1.214.787 2.128 1.942 2.928 3.385.014.024.026.05.037.075.603 1.448 1.065 4.135-.971 6.015-.74.682-1.676 1.024-2.352 1.27l-.282.105c-.378.144-.603.252-.735.36-.09.073-.103.111-.103.188 0 .217.048.333.093.403.048.076.13.155.28.243.156.09.352.17.607.264l.144.052c.21.076.453.164.681.266.86.382 1.279 1.32 1.202 2.23-.08.95-.674 1.9-1.817 2.535a9.715 9.715 0 0 1-4.189.945c-5.385 0-9.75-4.365-9.75-9.75Zm11.916-2.61a1.5 1.5 0 1 1 2.898.777 1.5 1.5 0 0 1-2.898-.777ZM7.818 7.45a1.5 1.5 0 1 1 2.898.776 1.5 1.5 0 0 1-2.898-.777Zm4.27-1.445a1.5 1.5 0 1 1 2.897.776 1.5 1.5 0 0 1-2.898-.776Z", fill: "currentColor" })));
});
export default SvgPaletteFill;
